export default __webpack_public_path__ + "static/06_Snake-f7b1cb36f50d3e09e4bd930c555ab7ef.png";